module.exports = ":host ::ng-deep img {\n  max-height: 350px; }\n"